import React, { FCC } from 'react'

import { IndexLayoutLoadingOld as BaseIndexLayoutLoading } from '../IndexLayoutOld'

export const IndexLayoutLoading: FCC = () => <BaseIndexLayoutLoading />
